module.exports = __webpack_public_path__ + "assets/img/image05.28975fe9.png";